module.exports = __webpack_public_path__ + "img/topicPersonalCare.7ab77c9f.png";